import * as React from 'react'

export function ArchitectureIcon({
  fill = '#8E24AA',
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Architecture icon"
      {...props}
    >
      <path
        d="M14.9994 8C14.9994 6.7 14.1594 5.6 12.9994 5.18V3H10.9994V5.18C9.83939 5.6 8.99939 6.7 8.99939 8C8.99939 9.66 10.3394 11 11.9994 11C13.6594 11 14.9994 9.66 14.9994 8ZM11.9994 9C11.4494 9 10.9994 8.55 10.9994 8C10.9994 7.45 11.4494 7 11.9994 7C12.5494 7 12.9994 7.45 12.9994 8C12.9994 8.55 12.5494 9 11.9994 9Z"
        fill={fill}
      />
      <path
        d="M14.7694 10.88C14.2794 11.35 13.6694 11.69 12.9994 11.86L15.7694 19.46L17.3894 21L17.6494 18.78L14.7694 10.88Z"
        fill={fill}
      />
      <path
        d="M6.35938 18.78L6.60938 21L8.22937 19.46L10.9994 11.86C10.3194 11.69 9.71937 11.35 9.22937 10.88L6.35938 18.78Z"
        fill={fill}
      />
    </svg>
  )
}
